export class IASCategoriesFetchFailed extends Error {
    constructor() {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, IASCategoriesFetchFailed);
        }
        this.name = "IASCategoriesFetchFailed";
        this.message = "Failed to fetch the IAS categories. Please try again at a later time.";
    }
}
//# sourceMappingURL=errors.js.map